module.exports = __webpack_public_path__ + "img/jbt3411_15_1999.prt.6c0c8437.jpg";